<template>
	<div class="ReportMap u-color-vars">
		<CloMapGoogle v-if="markers && markers.length > 0" :apiKey="apiKey" :mapTypeId="mapTypeId" :markers="markers" />
		<div v-if="markers && markers.length === 0" class="Map">
			<div class="AspectRatioContent">
				<div class="Map-empty">
					<p class="u-margin-none">{{ $t('data.noChecklists') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import CloMapGoogle from '@/maps/CloMapGoogle/CloMapGoogle.vue';
export default {
	name: 'ReportMap',
	components: {
		CloMapGoogle,
	},
	props: {
		tripId: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			apiKey: window.gmaps_key,
			tripApiBaseUrl: window.tripApiBaseUrl,
			mapTypeId: 'hybrid',
			markers: null,
			selectedPersonId: window.tripReportPersonId ? window.tripReportPersonId : '',
		};
	},
	mounted() {
		let url = this.tripApiBaseUrl + 'locations/' + this.tripId;
		const params = {};
		if (this.selectedPersonId) {
			params.tripReportPersonId = this.selectedPersonId;
		}
		axios
			.get(url, { params: params })
			.then((res) => {
				this.markers = res.data.map((loc) => {
					return {
						...loc,
						type: loc.isHotspot ? 'hotspot' : 'personal',
						position: {
							lat: loc.lat,
							lng: loc.lng,
						},
						content: loc.hierarchicalName,
					};
				});
			})
			.catch((err) => {
				console.log(err);
			});
	},
};
</script>

<style lang="scss">
.ReportMap {
	height: 100%;
	width: 100%;
	.Map {
		color: var(--color-text);
		@include aspect-ratio(16, 9);
		@include breakpoint(xlarge) {
			@include aspect-ratio(21, 9);
		}
	}
	.Map-empty {
		background-color: transparentize($color-black, 0.75);
		@include inset-md;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: $color-text-reverse;
	}
}
.print {
	.Map {
		max-height: 16rem;
	}
}
</style>
